module.exports = __webpack_public_path__ + "static/media/icon-expand-order.58d7196a.svg";